<template>
  <div>
    <div class="page-head">
      <div>
        <h2>文化体验</h2>
        <p>维护文化体验页展示的体验项目、封面和推荐状态。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增体验</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="体验名称/分类/介绍" clearable /></el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="体验名称" min-width="180" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column prop="duration" label="时长" width="120" />
        <el-table-column prop="suitable_people" label="适合人群" min-width="160" />
        <el-table-column label="标签" min-width="180">
          <template slot-scope="{ row }">
            <el-tag v-for="tag in normalizeTags(row.tags_json)" :key="tag" size="mini" class="table-tag">{{ tag }}</el-tag>
            <span v-if="!normalizeTags(row.tags_json).length" class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="小程序展示" width="160">
          <template slot-scope="{ row }"><publish-switch :value="row.status" @change="changeStatus(row, $event)" /></template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增文化体验' : '编辑文化体验'" :visible.sync="drawerVisible" width="600px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="体验名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="分类">
          <el-select v-model="form.category" filterable allow-create default-first-option placeholder="选择或输入分类">
            <el-option label="胡同体验" value="胡同体验" />
            <el-option label="京味演出" value="京味演出" />
            <el-option label="非遗手作" value="非遗手作" />
          </el-select>
        </el-form-item>
        <el-form-item label="体验时长"><el-input v-model="form.duration" /></el-form-item>
        <el-form-item label="适合人群"><el-input v-model="form.suitable_people" /></el-form-item>
        <el-form-item label="封面图" prop="cover_url"><asset-upload v-model="form.cover_url" type="image" category="culture" /></el-form-item>
        <el-form-item label="详情图"><asset-upload v-model="form.detail_image_url" type="image" category="culture" /></el-form-item>
        <el-form-item label="体验标签">
          <div class="tag-editor">
            <el-tag v-for="tag in form.tags_json" :key="tag" closable @close="removeTag(tag)">{{ tag }}</el-tag>
            <el-input
              v-if="tagInputVisible"
              ref="tagInput"
              v-model="tagInput"
              class="tag-input"
              size="small"
              @keyup.enter.native="confirmTag"
              @blur="confirmTag"
            />
            <el-button v-else size="small" @click="showTagInput">添加标签</el-button>
          </div>
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort_order" :min="0" :precision="0" /></el-form-item>
        <el-form-item label="小程序展示"><el-switch v-model="form.status" active-value="active" inactive-value="inactive" /></el-form-item>
        <el-form-item label="体验介绍"><el-input v-model="form.description" type="textarea" :rows="5" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import PagedTable from "../components/PagedTable.vue";
import PublishSwitch from "../components/PublishSwitch.vue";
import SortInput from "../components/SortInput.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

export default {
  name: "CultureExperiencesManage",
  components: { AssetUpload, PagedTable, PublishSwitch, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      tagInput: "",
      tagInputVisible: false,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: "请填写体验名称", trigger: "blur" }],
        cover_url: [{ required: true, message: "请上传封面图", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        category: "",
        duration: "",
        suitable_people: "",
        cover_url: "",
        detail_image_url: "",
        tags_json: [],
        cta_type: "detail",
        is_featured: false,
        status: "active",
        sort_order: 0,
        description: ""
      };
    },
    normalizeTags(value) {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (error) {
        return String(value)
          .split(/[，,]/)
          .map((item) => item.trim())
          .filter(Boolean);
      }
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("culture-experiences", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.tagInput = "";
      this.tagInputVisible = false;
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, tags_json: this.normalizeTags(row.tags_json), is_featured: Boolean(row.is_featured) };
      this.tagInput = "";
      this.tagInputVisible = false;
      this.drawerVisible = true;
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        if (this.$refs.tagInput) this.$refs.tagInput.focus();
      });
    },
    confirmTag() {
      const value = this.tagInput.trim();
      if (value && !this.form.tags_json.includes(value)) {
        this.form.tags_json.push(value);
      }
      this.tagInput = "";
      this.tagInputVisible = false;
    },
    removeTag(tag) {
      this.form.tags_json = this.form.tags_json.filter((item) => item !== tag);
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.drawerMode === "create") await createResource("culture-experiences", this.form);
          else await updateResource("culture-experiences", this.form.id, this.form);
          this.$message.success("文化体验已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("culture-experiences", row.id, status);
      this.$message.success(status === "active" ? "体验已展示" : "体验已隐藏");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("culture-experiences", row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("确定删除该文化体验吗？", "删除体验", { type: "warning" })
        .then(async () => {
          await deleteResource("culture-experiences", row.id);
          this.$message.success("文化体验已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>
